<script>
//import axios from "axios";

import Layout from "../../layouts/auth";

import appConfig from "@/app.config";
import { required } from "vuelidate/lib/validators";

/**
 * Verify component
 */
export default {
  page: {
    title: "Verify Account",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
  },
  data() {
    return {
      submitted: false,
      otp: null,
      authError: "",
      isAuthError: false,
    };
  },
  validations: {
    otp: {
      required,
    },
  },
  methods: {
    resendOTP() {

    },
    verify() {
      this.submitted = true;
      // stop here if form is invalid
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      } else {
        setTimeout(() => {
          this.isAuthError = true;
          this.authError = "Invalid Otp";
        }, 3000);
      }
      this.submitted = false;
    },
  },
};
</script>

<template>
  <Layout>
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card overflow-hidden">
          <div class="bg-soft bg-primary">
            <div class="row">
              <div class="col-8">
                <div class="text-primary p-4">
                  <h5 class="text-primary">Welcome to <span class="fs-4 text-success">WorkRhytm</span></h5>
                  <p>Verify Account</p>
                </div>
              </div>
              <div class="col-4 align-self-end">
                <img
                  src="@/assets/images/profile-img.png"
                  alt
                  class="img-fluid"
                />
              </div>
            </div>
          </div>
          <div class="card-body pt-0">
            <div>
              <router-link to="/">
                <div class="avatar-md profile-user-wid mb-4">
                  <span class="avatar-title rounded-circle bg-light">
                    <img src="@/assets/images/logo-blue.png" alt height="48" />
                  </span>
                </div>
              </router-link>
            </div>
            <b-alert
              v-model="isAuthError"
              variant="danger"
              class="mt-3"
              dismissible
              >{{ authError }}</b-alert
            >
            <!-- <div
              v-if="notification.message"
              :class="'alert ' + notification.type"
            >
              {{ notification.message }}
            </div> -->

            <b-form class="p-2" @submit.prevent="verify">
              <div class="mb-3">
                  <label for="otp"> Otp</label>
                  <input
                    type="text"
                    v-model="otp"
                    class="form-control"
                    id="otp"
                    placeholder="Enter otp"
                    :class="{ 'is-invalid': submitted && $v.otp.$error }"
                  />
                  <div
                    v-if="submitted && $v.otp.$error"
                    class="invalid-feedback"
                  >
                    <span v-if="!$v.otp.required">OTP is required.</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 text-end">
                    <button class="btn btn-link w-md" @click="resendOTP" type="button">
                      Resend OTP
                    </button>
                  </div>
                   </div>
                <div class="mb-3 row mb-0">
                  <div class="col-6 mt-3">
                  </div>
                  <div class="col-6 text-end mt-3">
                    <button class="btn btn-primary w-md" type="submit">
                      Verify
                    </button>
                  </div>
                </div>
            </b-form>
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->

        <div class="mt-5 text-center">
          <p>
            Change Email?
            <router-link
              to="/login"
              class="fw-medium text-primary"
              >Sign In Here</router-link
            >
          </p>
           <p>
            Don't have an account ?
            <router-link
              to="/register"
              class="fw-medium text-primary"
              >Signup now</router-link
            >
          </p>
          <!--<p>
            © {{ new Date().getFullYear() }} Skote. Crafted with
            <i class="mdi mdi-heart text-danger"></i> by Themesbrand
          </p>-->
        </div>
        <!-- end row -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>